var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "navbar navbar-footer navbar-expand-md fixed-bottom navbar-light bg-light"
    },
    [
      _c("div", { staticClass: "navbar-brand d-none d-md-block" }, [
        _vm._v("National Information Exchange Model (NIEM)")
      ]),
      _c("div", { staticClass: "navbar-brand d-md-none" }, [
        _vm._v("National Information Exchange Model")
      ]),
      _c("menu-toggler", { attrs: { toggleID: _vm.toggleID } }),
      _c("footer-links", { attrs: { toggleID: _vm.toggleID } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }